/**
 * 控制类型
 * @param ml 左边控制按钮(缩放)
 * @param mr 右边控制按钮(缩放)
 * @param mt 上边控制按钮(缩放)
 * @param mb 下边控制按钮(缩放)
 * @param mll 左边控制按钮(连线)
 * @param mlr 右边控制按钮(连线)
 * @param mtl 上边控制按钮(连线)
 * @param mtr 下边控制按钮(连线)
 */
export enum IControlType {
  ml = "ml",
  mr = "mr",
  mt = "mt",
  mb = "mb",
  mll = "mll",
  mrl = "mrl",
  mtl = "mtl",
  mbl = "mbl",
}
